export default __webpack_public_path__ + "static/media/sixth-strip.3d01ad12.png";